import ApiClient from "./apiClient";
import { getListParams, QueriesApi } from "./apiTypes";



const notificationService = {
  getNotifications:(queries:QueriesApi) => ApiClient.get('notifications', {
    params: {
      ...getListParams(queries),
      ordering: queries.ordering || '-generated',
      name: 'frontend',
    }
  }),
  markAllAsRead: () => ApiClient.post('notifications/mark_all_as_read'),
  markAsUnread: (notificationId:string|number) => ApiClient.post(`notifications/${notificationId}/unseen`),
  viewNotification:(notificationId:string|number) => ApiClient.post(`notifications/${notificationId}/view`),
  getById:(notificationId:string|number) => ApiClient.get(`notifications/${notificationId}`),
  getPanelNotifications:(queries?:QueriesApi) => ApiClient.get(`/notifications/get_panel_notifications`,{
    // params:{
    //   page: queries.page,
    //   page_size: queries.pageSize,
    //   ordering: queries.ordering,
    //   search: queries.search
    // }
  })
}

export default notificationService
